<template>
  <div
    v-loading="loading"
    class="app-main-content"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <div class="tabs-container">
      <el-tabs
        v-model="activeTabName"
        type="card"
        style="width:100%"
        @tab-click="handleTabClick"
      >
        <el-tab-pane
          :label="$t('baseInfo.seaport.tabPort.tabName')"
          name="port"
          no="port"
        >
          <port ref="port" />
        </el-tab-pane>
        <el-tab-pane
          :lazy="true"
          :label="$t('baseInfo.seaport.tabEdiPort.tabName')"
          name="ediPort"
          no="ediPort"
        >
          <edi-port ref="ediPort" />
        </el-tab-pane>
        <el-tab-pane
          :lazy="true"
          :label="$t('baseInfo.seaport.tabAmsPort.tabName')"
          name="amsPort"
          no="amsPort"
        >
          <ams-port ref="ams-port" />
        </el-tab-pane>
      </el-tabs>
      <div
        v-show="loading"
        style="position: fixed;z-index: 9999;height: 100%;width: 100%;background-color: #2d3a4b22;
      display: flex;justify-content: center;align-items:center"
      >
        <svg-icon
          icon-class="loading-bars"
          style="font-size:60px;"
        />
      </div>
    </div>
  </div>
</template>
<script>
import port from './components/port'
import ediPort from './components/ediPort'
import amsPort from './components/amsPort'

export default {
  name: 'SeaPort',
  components: {
    port,
    ediPort,
    amsPort
  },
  filters: {

  },
  data() {
    return {
      loading: false,
      activeTabName: 'port'
    }
  },
  computed: {

  },
  watch: {
    $route: {
      handler: function(route) {
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    handleTabClick() {
      switch (this.activeTabName) {
        case 'ediPort':
          if (this.$refs.ediPort) {
            this.$refs.ediPort.onShow()
          } else {
            setTimeout(() => {
              this.$refs.ediPort.onShow()
            })
          }
          break
        default:
          break
      }
    },
    onReady(params) {
    }
  }
}
</script>
